import React, { useEffect, useState, useRef } from 'react';
import { Button, Modal } from 'antd';
import {
  CREATE_USER_MEMBER,
  MOBILE_SEND_VERFIY,
  MOBILE_VERFIY_SEND,
  VERIFY_USER,
} from './../../Utils/appConstants';
import { postRequest } from './../../Utils/AppApi';
import { getUser, isNumber } from "./../../Utils/Common";
import { useHistory } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import RiseLoader from 'react-spinners/RiseLoader';
import { UserOutlined, CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

const userData = getUser();

function CreateMember(props) {
  const mobileNumberRef = useRef(null);
  const otpNumberRef = useRef(null);
  const pancardNumberRef = useRef(null);
  const aadharNumberRef = useRef(null);
  const addressRef = useRef(null);

  const history = useHistory();

  const [isData, setData] = useState({
    mobileNumber: '',
    OtpNumber: '',
    pancardNumber: '',
    aadharNumber: '',
    address: '',
  });

  const [errors, setErrors] = useState({
    pancardNumber: '',
    mobileNumber: '',
    OtpNumber: '',
    aadharNumber: '',
    address: '',
  });

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [roleId, setRoleId] = useState(userData?.data?.role?.code);
  const [isOtpNumber, setOtpNumber] = useState(false);
  const [isMobileNumberVerify, setMobileNumberVerify] = useState(false);
  const [showingSubmitPopup, setShowingSubmitPopup] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [touched, setTouched] = useState({
    pancardNumber: false,
    mobileNumber: false,
    OtpNumber: false,
    aadharNumber: false,
    address: false,
  });

  // Step control
  const [showDetailsForm, setShowDetailsForm] = useState(false);    // after OTP verification
  const [isVerified, setIsVerified] = useState(false);             // after PAN/Aadhar verification

  // Store verification data
  const [pancardData, setPancardData] = useState(null);           // <-- new state

  // Validation functions
  const validateField = (name, value) => {
    let error = '';
    switch(name) {
      case 'pancardNumber':
        if (!value || value.trim() === '') {
          error = 'PAN card number is required';
        } else {
          const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
          if (!panRegex.test(value.trim().toUpperCase())) {
            error = 'Enter a valid PAN number (e.g., ABCDE1234F)';
          }
        }
        break;
      case 'aadharNumber':
        if (!value || value.trim() === '') {
          error = 'Aadhar number is required';
        } else if (!/^\d{12}$/.test(value)) {
          error = 'Enter a valid 12-digit Aadhar number';
        }
        break;
      case 'address':
        if (!value || value.trim() === '') {
          error = 'Address is required';
        } else if (value.length < 5) {
          error = 'Address must be at least 5 characters';
        }
        break;
      case 'mobileNumber':
        if (!value || value.trim() === '') error = 'Mobile number is required';
        else if (!/^\d{10}$/.test(value)) error = 'Enter a valid 10-digit mobile number';
        break;
      case 'OtpNumber':
        if (!value || value.trim() === '') error = 'OTP is required';
        else if (!/^\d{4}$/.test(value)) error = 'Enter a valid 4-digit OTP';
        break;
      default:
        break;
    }
    return error;
  };

  const handleBlur = (fieldName, value) => {
    setTouched({ ...touched, [fieldName]: true });
    const error = validateField(fieldName, value);
    setErrors({ ...errors, [fieldName]: error });
  };

  const validateDetailsForm = () => {
    const newErrors = {
      pancardNumber: validateField('pancardNumber', isData.pancardNumber),
      aadharNumber: validateField('aadharNumber', isData.aadharNumber),
      address: validateField('address', isData.address),
    };
    setErrors(newErrors);
    setTouched({
      pancardNumber: true,
      aadharNumber: true,
      address: true,
    });
    return !Object.values(newErrors).some(error => error !== '');
  };

  const clearFormField = () => {
    setData({
      mobileNumber: '',
      OtpNumber: '',
      pancardNumber: '',
      aadharNumber: '',
      address: '',
    });
    setErrors({
      pancardNumber: '',
      mobileNumber: '',
      OtpNumber: '',
      aadharNumber: '',
      address: '',
    });
    setTouched({
      pancardNumber: false,
      mobileNumber: false,
      OtpNumber: false,
      aadharNumber: false,
      address: false,
    });
    setFirstName('');
    setLastName('');
    setPancardData(null);          // <-- clear verified data
    setOtpNumber(false);
    setMobileNumberVerify(false);
    setShowDetailsForm(false);
    setIsVerified(false);
    if (mobileNumberRef.current) mobileNumberRef.current.value = '';
    if (otpNumberRef.current) otpNumberRef.current.value = '';
    if (pancardNumberRef.current) pancardNumberRef.current.value = '';
    if (aadharNumberRef.current) aadharNumberRef.current.value = '';
    if (addressRef.current) addressRef.current.value = '';
  };

  // Send OTP
  const handleVerifyMobileNumber = () => {
    const mobileError = validateField('mobileNumber', isData.mobileNumber);
    if (mobileError) {
      setErrors({ ...errors, mobileNumber: mobileError });
      setTouched({ ...touched, mobileNumber: true });
      toast.error(mobileError);
      return;
    }

    setLoading(true);
    const payload = {
      mobile: isData.mobileNumber,
      roleId: roleId,
    };

    postRequest(MOBILE_VERFIY_SEND, payload, history)
      .then((response) => {
        if (response.success === true) {
          toast.success(response.message);
          setOtpNumber(true);
        } else {
          toast.error(response.message || 'Failed to send OTP');
        }
      })
      .catch(() => toast.error('Failed to send OTP'))
      .finally(() => setLoading(false));
  };

  // Verify OTP
  const handleVerifyOtpMobileNumber = () => {
    const otpError = validateField('OtpNumber', isData.OtpNumber);
    if (otpError) {
      setErrors({ ...errors, OtpNumber: otpError });
      setTouched({ ...touched, OtpNumber: true });
      toast.error(otpError);
      return;
    }

    setLoading(true);
    const payload = {
      mobile: isData.mobileNumber,
      otp: isData.OtpNumber,
    };

    postRequest(MOBILE_SEND_VERFIY, payload, history)
      .then((response) => {
        if (response.success === true) {
          toast.success(response.message);
          setOtpNumber(false);
          setMobileNumberVerify(true);
          setShowDetailsForm(true);   // show PAN/Aadhar/Address form
        } else {
          toast.error(response.message || 'OTP verification failed');
        }
      })
      .catch(() => toast.error('OTP verification failed'))
      .finally(() => setLoading(false));
  };

  // Step 2: Verify PAN & Aadhar (Next button)
  const handleVerifyPANAndAadhar = async () => {
    if (!validateDetailsForm()) {
      toast.error('Please fix all errors before proceeding');
      return;
    }

    setLoading(true);
    const verifyPayload = {
      pancard: isData.pancardNumber.trim().toUpperCase(),
      aadhar: isData.aadharNumber.trim(),
      mobile: isData.mobileNumber,
    };

    try {
      const response = await postRequest(VERIFY_USER, verifyPayload, history);
      if (!response || !response.success) {
        toast.error(response?.message || 'PAN / Aadhar verification failed');
        setLoading(false);
        return;
      }

      // Extract full data from response
      const data = response.data || {};
      // Store the complete pancard data
      setPancardData(data);                // <-- store full verification data

      // Extract name
      let fName = data.first_name || '';
      let lName = data.last_name || '';
      if (!fName && data.registered_name) {
        const parts = data.registered_name.trim().split(/\s+/).filter(Boolean);
        fName = parts[0] || '';
        lName = parts.slice(1).join(' ') || '';
      }
      if (!fName && data.name_pan_card) {
        const parts = data.name_pan_card.trim().split(/\s+/).filter(Boolean);
        fName = parts[0] || '';
        lName = parts.slice(1).join(' ') || '';
      }

      setFirstName(fName);
      setLastName(lName);
      setIsVerified(true);
      toast.success('PAN & Aadhar verified successfully!');

    } catch (error) {
      console.error('Verification error:', error);
      toast.error('An error occurred during verification');
    } finally {
      setLoading(false);
    }
  };

  // Step 3: Submit - create member
  const handleSubmitAPI = async () => {
    if (!isVerified) {
      toast.error('Please verify PAN and Aadhar first');
      return;
    }

    setLoading(true);

    // Prepare payload
    const createPayload = {
      firstName: firstName,
      lastName: lastName,
      mobile: isData.mobileNumber,
      pancard: isData.pancardNumber.trim().toUpperCase(),
      aadharNumber: isData.aadharNumber.trim(),
      address: isData.address.trim(),
      pancardData: pancardData,          // <-- include the verified data
      // roleCode: roleId, // optional, backend will use default if not provided
    };

    try {
      const response = await postRequest(CREATE_USER_MEMBER, createPayload, history);
      if (response && response.success) {
        setShowingSubmitPopup(true);
        setUsername(response.data?.username || '');
        setPassword(response.data?.password || '');
        toast.success(response.message || 'Member created successfully!');
        setTimeout(() => clearFormField(), 2000);
      } else {
        toast.error(response?.message || 'Member creation failed');
      }
    } catch (error) {
      console.error('Create member error:', error);
      toast.error('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCancelPopup = () => {
    setShowingSubmitPopup(false);
    setUsername("");
    setPassword("");
    clearFormField();
  };

  const onChangeValue = (event) => {
    const { name, value } = event.target;
    let newValue = value;

    if (name === "pancardNumber") {
      newValue = value.toUpperCase();
    } else if (name === "mobileNumber") {
      const digitsOnly = value.replace(/\D/g, '');
      if (digitsOnly.length <= 10) newValue = digitsOnly;
      else return;
    } else if (name === "OtpNumber") {
      const digitsOnly = value.replace(/\D/g, '');
      if (digitsOnly.length <= 4) newValue = digitsOnly;
      else return;
    } else if (name === "aadharNumber") {
      const digitsOnly = value.replace(/\D/g, '');
      if (digitsOnly.length <= 12) newValue = digitsOnly;
      else return;
    }

    setData({ ...isData, [name]: newValue });
    if (errors[name]) setErrors({ ...errors, [name]: '' });
  };

  useEffect(() => {
    setRoleId(userData?.data?.role?.code);
  }, []);

  if (isLoading) {
    return (
      <div className="content text-center" style={{ margin: '250px 0' }}>
        <RiseLoader color="#C9262C" loading={isLoading} size={25} />
      </div>
    );
  }

  // Styles (same as before)
  const styles = {
    pageWrapper: { background: '#ffffff', minHeight: '100vh', padding: '60px 0' },
    container: { maxWidth: '1000px', margin: '0 auto', padding: '0 24px' },
    card: { background: 'white', borderRadius: '20px', boxShadow: '0 20px 40px rgba(0,0,0,0.1)', overflow: 'hidden', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', border: '1px solid #FFDD09' },
    leftPanel: { flex: '1', background: 'linear-gradient(135deg, #C9262C 0%, #FFDD09 100%)', padding: '48px 32px', color: 'white', minWidth: '260px' },
    rightPanel: { flex: '1.4', padding: '48px 40px', minWidth: '320px', background: 'white' },
    welcomeTitle: { fontSize: '28px', fontWeight: '700', marginBottom: '12px' },
    welcomeText: { fontSize: '14px', opacity: '0.9', marginBottom: '40px', lineHeight: '1.6' },
    feature: { display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' },
    featureIcon: { width: '36px', height: '36px', background: 'rgba(255,255,255,0.2)', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '18px' },
    formTitle: { fontSize: '24px', fontWeight: '600', marginBottom: '8px', color: '#C9262C' },
    formSubtitle: { fontSize: '14px', color: '#6b7280', marginBottom: '32px', paddingBottom: '16px', borderBottom: '2px solid #FFDD09' },
    formGroup: { marginBottom: '20px' },
    label: { display: 'block', fontWeight: '500', marginBottom: '8px', color: '#C9262C', fontSize: '13px' },
    requiredStar: { color: '#C9262C', marginLeft: '4px', fontSize: '14px' },
    inputWrapper: { display: 'flex', gap: '12px' },
    input: { width: '100%', borderRadius: '12px', border: '2px solid #e5e7eb', padding: '10px 16px', fontSize: '14px', transition: 'all 0.3s', outline: 'none', background: '#f9fafb' },
    inputError: { borderColor: '#C9262C', background: '#fff5f5' },
    errorMessage: { color: '#C9262C', fontSize: '12px', marginTop: '6px', display: 'flex', alignItems: 'center', gap: '4px' },
    row: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' },
    button: { borderRadius: '12px', height: '42px', padding: '0 24px', fontWeight: '600', border: 'none', cursor: 'pointer', fontSize: '14px', transition: 'all 0.3s' },
    buttonPrimary: { background: '#C9262C', color: 'white' },
    buttonSuccess: { background: '#FFDD09', color: '#C9262C' },
    verifiedBadge: { background: '#FFF9E6', border: '1px solid #FFDD09', borderRadius: '12px', padding: '12px', textAlign: 'center', color: '#C9262C', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', fontSize: '14px', fontWeight: '500' },
    hidden: { display: 'none' },
    readOnlyField: { background: '#f0f0f0', cursor: 'not-allowed' },
  };

  return (
    <div style={styles.pageWrapper}>
      <div style={styles.container}>
        <div style={styles.card}>
          <div style={styles.leftPanel}>
            <div style={styles.welcomeTitle}>Create Member</div>
            <div style={styles.welcomeText}>Add new members with secure verification</div>
            <div>
              <div style={styles.feature}>
                <div style={styles.featureIcon}><CheckCircleOutlined /></div>
                <div style={{ fontSize: '13px' }}><strong>Secure Verification</strong><br />PAN & Aadhar via API</div>
              </div>
              <div style={styles.feature}>
                <div style={styles.featureIcon}><UserOutlined /></div>
                <div style={{ fontSize: '13px' }}><strong>Quick Process</strong><br />Easy onboarding</div>
              </div>
            </div>
          </div>

          <div style={styles.rightPanel}>
            <div style={styles.formTitle}>Member Details</div>
            <div style={styles.formSubtitle}>Fill the information below</div>

            {/* Mobile Number & OTP */}
            <div style={styles.formGroup}>
              <label style={styles.label}>Mobile Number <span style={styles.requiredStar}>*</span></label>
              <div style={styles.inputWrapper}>
                <input
                  type="text"
                  name="mobileNumber"
                  placeholder="10-digit mobile number"
                  onChange={onChangeValue}
                  onBlur={(e) => handleBlur('mobileNumber', e.target.value)}
                  maxLength={10}
                  onKeyDown={isNumber}
                  value={isData.mobileNumber || ''}
                  style={{
                    ...styles.input,
                    ...(touched.mobileNumber && errors.mobileNumber ? styles.inputError : {}),
                  }}
                  readOnly={isOtpNumber || isMobileNumberVerify}
                />
                {!isMobileNumberVerify && !isOtpNumber && (
                  <Button
                    onClick={handleVerifyMobileNumber}
                    loading={isLoading}
                    style={{ ...styles.button, ...styles.buttonPrimary }}
                  >
                    Send OTP
                  </Button>
                )}
              </div>
              {touched.mobileNumber && errors.mobileNumber && (
                <div style={styles.errorMessage}>
                  <ExclamationCircleOutlined /> {errors.mobileNumber}
                </div>
              )}
            </div>

            {isOtpNumber && !isMobileNumberVerify && (
              <div style={styles.formGroup}>
                <label style={styles.label}>OTP Number <span style={styles.requiredStar}>*</span></label>
                <div style={styles.inputWrapper}>
                  <input
                    type="text"
                    name="OtpNumber"
                    placeholder="Enter 4-digit OTP"
                    onChange={onChangeValue}
                    onBlur={(e) => handleBlur('OtpNumber', e.target.value)}
                    maxLength={4}
                    onKeyDown={isNumber}
                    value={isData.OtpNumber || ''}
                    style={{
                      ...styles.input,
                      ...(touched.OtpNumber && errors.OtpNumber ? styles.inputError : {}),
                    }}
                  />
                  <Button
                    onClick={handleVerifyOtpMobileNumber}
                    loading={isLoading}
                    style={{ ...styles.button, ...styles.buttonSuccess }}
                  >
                    Verify OTP
                  </Button>
                </div>
                {touched.OtpNumber && errors.OtpNumber && (
                  <div style={styles.errorMessage}>
                    <ExclamationCircleOutlined /> {errors.OtpNumber}
                  </div>
                )}
              </div>
            )}

            {/* Step 2: PAN, Aadhar, Address */}
            <div style={showDetailsForm ? {} : styles.hidden}>
              <div style={styles.formGroup}>
                <label style={styles.label}>PAN Card Number <span style={styles.requiredStar}>*</span></label>
                <input
                  type="text"
                  name="pancardNumber"
                  placeholder="ABCDE1234F"
                  onChange={onChangeValue}
                  onBlur={(e) => handleBlur('pancardNumber', e.target.value)}
                  maxLength={10}
                  value={isData.pancardNumber || ''}
                  style={{
                    ...styles.input,
                    ...(touched.pancardNumber && errors.pancardNumber ? styles.inputError : {}),
                  }}
                  readOnly={isVerified}
                />
                {touched.pancardNumber && errors.pancardNumber && (
                  <div style={styles.errorMessage}><ExclamationCircleOutlined /> {errors.pancardNumber}</div>
                )}
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Aadhar Number <span style={styles.requiredStar}>*</span></label>
                <input
                  type="text"
                  name="aadharNumber"
                  placeholder="12-digit Aadhar number"
                  onChange={onChangeValue}
                  onBlur={(e) => handleBlur('aadharNumber', e.target.value)}
                  maxLength={12}
                  onKeyDown={isNumber}
                  value={isData.aadharNumber || ''}
                  style={{
                    ...styles.input,
                    ...(touched.aadharNumber && errors.aadharNumber ? styles.inputError : {}),
                  }}
                  readOnly={isVerified}
                />
                {touched.aadharNumber && errors.aadharNumber && (
                  <div style={styles.errorMessage}><ExclamationCircleOutlined /> {errors.aadharNumber}</div>
                )}
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Address <span style={styles.requiredStar}>*</span></label>
                <textarea
                  name="address"
                  placeholder="Enter full address"
                  onChange={onChangeValue}
                  onBlur={(e) => handleBlur('address', e.target.value)}
                  rows={2}
                  value={isData.address || ''}
                  style={{
                    ...styles.input,
                    ...(touched.address && errors.address ? styles.inputError : {}),
                    resize: 'vertical',
                  }}
                  readOnly={isVerified}
                />
                {touched.address && errors.address && (
                  <div style={styles.errorMessage}><ExclamationCircleOutlined /> {errors.address}</div>
                )}
              </div>

              {/* Show fetched name after verification */}
              {isVerified && (
                <div style={{ ...styles.formGroup, background: '#f9fafb', padding: '12px', borderRadius: '12px' }}>
                  <label style={styles.label}>Verified Name (from PAN/Aadhar)</label>
                  <div style={{ fontSize: '16px', fontWeight: '500', color: '#1f2937' }}>
                    {firstName} {lastName}
                  </div>
                </div>
              )}

              <div style={{ marginTop: '24px', textAlign: 'right' }}>
                {!isVerified ? (
                  <Button
                    onClick={handleVerifyPANAndAadhar}
                    loading={isLoading}
                    style={{ ...styles.button, ...styles.buttonPrimary, minWidth: '120px' }}
                  >
                    Next
                  </Button>
                ) : (
                  <Button
                    onClick={handleSubmitAPI}
                    loading={isLoading}
                    style={{ ...styles.button, ...styles.buttonSuccess, minWidth: '120px' }}
                  >
                    Submit
                  </Button>
                )}
              </div>
            </div>

            {isMobileNumberVerify && !showDetailsForm && (
              <div style={styles.verifiedBadge}>
                <CheckCircleOutlined /> Mobile verified! Please fill the remaining details.
              </div>
            )}
          </div>
        </div>

        {/* Success Modal */}
        <Modal open={showingSubmitPopup} footer={null} onCancel={handleCancelPopup} centered width={440}>
          <div style={{ textAlign: 'center', padding: '32px 24px' }}>
            <div style={{ width: '64px', height: '64px', background: '#C9262C', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 20px' }}>
              <CheckCircleOutlined style={{ fontSize: '32px', color: '#FFDD09' }} />
            </div>
            <h3 style={{ fontSize: '20px', marginBottom: '8px', color: '#C9262C' }}>Registration Successful!</h3>
            <p style={{ color: '#6b7280', marginBottom: '20px' }}>Member account created</p>
            <div style={{ background: '#f3f4f6', padding: '16px', borderRadius: '12px', marginBottom: '20px', textAlign: 'left' }}>
              <p style={{ marginBottom: '8px' }}><strong>Username:</strong> {username}</p>
              <p style={{ marginBottom: 0 }}><strong>Password:</strong> {password}</p>
            </div>
            <Button onClick={handleCancelPopup} block style={{ borderRadius: '10px', height: '42px', background: '#C9262C', color: 'white', border: 'none' }}>
              Continue
            </Button>
          </div>
        </Modal>

        <ToastContainer position="top-right" autoClose={5000} />
      </div>
    </div>
  );
}

export default CreateMember;